import { pipe } from 'fp-ts/lib/function';

/**
 * Format a distance in meters to km
 *
 * @param meters
 * @returns
 */
export const formatDistance = (meters: number) => {
  const f = Intl.NumberFormat(undefined, {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
  return pipe(meters, (m) => m / 1000, f.format);
};
